import Vue from "vue";
import Vuex from "vuex";
import {
  queryMyselfInfo
} from "@/services/user/index.js";
// import {
//   queryMyselfStore
// } from "@/services/mall/store.js";
//1. 安装
Vue.use(Vuex);
var store = new Vuex.Store({
  state: {
    //TODO:登录后的token,1天失效
    storeToken: "",
    //用户信息: 导航权限 店铺权限
    userInfo: {},
    //全量导航  routerName: "Management"
    navList: [
      //系统管理
      {
        id: "1",
        label: "超级管理员",
        icon: "el-icon-setting",
        routerName: "system",
        disabled: true,
        children: [{
          id: "1-1",
          label: "账号管理",
          routerName: "SysUser",
          path: "/management/system/user",
          disabled: true,
        },
        {
          id: "1-2",
          label: "角色管理",
          routerName: "AuthGroup",
          path: "/management/system/authGroup",
          disabled: true,
        },
        ],
      },
      //小程序管理
      {
        id: "2",
        label: "配置信息",
        // icon: "el-icon-s-data",
        icon: "el-icon-s-platform",
        // icon: "el-icon-s-shop",
        routerName: "MiniApp",
        children: [
          {
            id: "2-1",
            label: "轮播图管理",
            routerName: "MiniAppBanner",
            path: "/management/miniApp/banner",
          },
          // {
          //   id: "2-2",
          //   label: "门店信息管理",
          //   routerName: "StoreList",
          //   path: "/management/store/storeList",
          // },
          // {
          //   id: "2-3",
          //   label: "公众号文章配置",
          //   routerName: "MiniAppArticle",
          //   path: "/management/miniApp/article",
          // },
        ],
      },

      //会员管理
      {
        id: "5",
        label: "用户数据管理",
        icon: "el-icon-star-off",
        routerName: "MallVipCard",
        path: "/management/store/vipCard",
        children: [
          {
            id: "5-0",
            label: "用户数据",
            routerName: "MallUser",
            path: "/management/miniApp/user",
          }, {
            id: "5-1",
            label: "积分记录",
            routerName: "DakaRecord",
            path: "/management/miniApp/dakaRecord",
          }, {
            id: "5-2",
            label: "会员列表",
            routerName: "MallVipCardList",
            path: "/management/vipCard/vipCardList",
            // disabled: true,
          },
          {
            id: "5-3",
            label: "会员交易记录",
            routerName: "MallVipCardRecode",
            path: "/management/vipCard/vipCardRecode",
          },
        ],
      },
      // {
      //   id: "6",
      //   label: "优惠券&卡券",
      //   icon: "el-icon-star-off",
      //   routerName: "MallVipCard",
      //   path: "/management/store/vipCard",
      //   children: [
      //     {
      //       id: "6-1",
      //       label: "优惠券列表",
      //       routerName: "CouponList",
      //       path: "/management/couponList",
      //     },
      //     {
      //       id: "6-2",
      //       label: "卡券列表",
      //       routerName: "CouponCard",
      //       path: "/management/couponCard",
      //     },
      //   ],
      // },

      //商城管理
      {
        id: "3",
        label: "商城管理",
        icon: "el-icon-s-shop",
        routerName: "Mall",
        children: [
          {
            id: "3-1",
            label: "商品管理",
            routerName: "MallGoods",
            children: [
              {
                id: "3-1-1",
                label: "商品分类",
                routerName: "MallGoodsKind",
                path: "/management/store/mallGoods/goodsKind",
              },
              {
                id: "3-1-2",
                label: "商品列表",
                routerName: "MallGoodsList",
                path: "/management/store/mallGoods/goodsList",
              },
            ],
          },
          {
            id: "3-2",
            label: "积分商城",
            routerName: "IntegralGoods",
            children: [
              {
                id: "3-2-1",
                label: "商品分类",
                routerName: "IntegralGoodsKind",
                path: "/management/store/integralGoods/goodsKind",
              },
              {
                id: "3-2-2",
                label: "商品列表",
                routerName: "IntegralGoodsList",
                path: "/management/store/integralGoods/goodsList",
              },
            ],
          },
          {
            id: "3-3",
            label: "优惠券列表",
            routerName: "CouponList",
            path: "/management/couponList",
          },
        ],
      },
      {
        id: "4",
        label: "订单中心", //门店,简古香铺,积分商城 3大类订单
        icon: "el-icon-s-order",
        routerName: "Order",
        path: "/management/store/order",
      },

      //个人页
      {
        id: "8",
        label: "个人页",
        icon: "el-icon-s-custom",
        routerName: "Person",
        children: [{
          id: "8-1",
          label: "个人中心",
          routerName: "PersonCenter",
          path: "/management/person/center",
        },],
      },
    ],
    //登录后筛选的导航
    filterNavList: [],
    //登录后筛选的店铺列表
    filterStoreList: [],
    //高亮导航项
    active: "",
  },
  //变更状态
  mutations: {
    updataUserInfo(state, value) {
      state.userInfo = value;
    },
    updataFilterNavList(state, value) {
      state.filterNavList = value;
    },
    updataFilterStoreList(state, value) {
      state.filterStoreList = value;
    },
    updataActive(state, value) {
      state.active = value;
    },
  },
  actions: {
    /* 用户信息权限,店铺信息初始化 */
    async getUserInfoAction({
      commit,
      state,
      dispatch
    }) {
      const userInfo = await queryMyselfInfo();
      commit("updataUserInfo", userInfo.data);

      // const storeList = await queryMyselfStore({
      //   store_id: userInfo.data.store_id || "",
      // });

      // commit("updataFilterStoreList", storeList.data);

      //用户无权限拦截
      if (!state.userInfo.rules) {
        return new Promise((reslove, reject) => {
          reslove({
            code: 201,
            routerName: "Errow",
            message: "当前账号权限不足",
          });
        });
      }

      //根据用户权限初始化导航数据
      var copyNavList = JSON.parse(JSON.stringify(state.navList));
      var roleList = state.userInfo.rules?.split(",");
      await dispatch("getFilterNavListAction", {
        copyNavList,
        roleList,
      });
      commit("updataFilterNavList", copyNavList); //根据用户权限完成导航筛选

      /* 定位第一个导航 */
      const routerName = await dispatch("findFirstRouterName", copyNavList);
      return new Promise((reslove, reject) => {
        reslove({
          code: 200,
          routerName,
        });
      });
    },

    /* 导航筛选 */
    async getFilterNavListAction({
      dispatch,
      commit
    }, {
      copyNavList,
      roleList
    }) {
      for (var index = copyNavList.length - 1; index >= 0; index--) {
        if (
          copyNavList[index]?.children &&
          copyNavList[index]?.children.length > 0 &&
          roleList?.indexOf(copyNavList[index].id) >= 0
        ) {
          await dispatch("getFilterNavListAction", {
            copyNavList: copyNavList[index].children,
            roleList: roleList,
          });
        }
        if (roleList?.indexOf(copyNavList[index]?.id) < 0) {
          copyNavList.splice(index, 1);
        }
      }
    },

    /*  找到第一个导航最深层routerName */
    async findFirstRouterName({
      dispatch,
      commit
    }, copyNavList) {
      if (copyNavList[0]?.children && copyNavList[0]?.children.length > 0) {
        return await dispatch("findFirstRouterName", copyNavList[0]?.children);
      } else {
        return copyNavList[0].routerName;
      }
    },

    /* 找到导航active */
    async findActive({
      dispatch,
      commit
    }, {
      filterNavList,
      path
    }) {
      for (let index = 0; index < filterNavList.length; index++) {
        if (filterNavList[index]?.path === path) {
          commit("updataActive", filterNavList[index]?.id);
        }
        if (
          filterNavList[index]?.children &&
          filterNavList[index]?.children.length > 0 &&
          filterNavList[index]?.path !== path
        ) {
          await dispatch("findActive", {
            filterNavList: filterNavList[index]?.children,
            path,
          });
        }
      }
    },
  },

  /* 计算属性 */
  getters: {},
});
export default store;